import cpdirect from '@@images/cpdirect/firm_logo2.png';
import powrog from '@@images/powrog/firm_logo2.png';
import flg from '@@images/flg/firm_logo2.png';
import mmlf from '@@images/mmlf/firm_logo2.png';
import klaw from '@@images/klaw/firm_logo2.png';
import flaw from '@@images/flaw/firm_logo2.png';
import cfs from '@@images/cfs/firm_logo2.png';
import slaw from '@@images/slaw/firm_logo2.png';
import mmdc from '@@images/mmdc/firm_logo2.png';
import ksbr from '@@images/ksbr/firm_logo2.png';
import vanstone from '@@images/vanstone/firm_logo2.png';
import wieand from '@@images/wieand/firm_logo2.png';
import wamsley from '@@images/wamsley/firm_logo2.png';
import lacpd from '@@images/lacpd/firm_logo2.png';
import gd from '@@images/gd/firm_logo2.png';
import coleman from '@@images/coleman/firm_logo2.png';
import { Brand } from '~utils/brand';

export const BrandLogoDark = () => {
	switch (Brand()) {
	case 'cpdirect':
		return cpdirect;
	case 'powrog':
		return powrog;
	case 'flg':
		return flg;
	case 'mmlf':
		return mmlf;
	case 'klaw':
		return klaw;
	case 'flaw':
		return flaw;
	case 'cfs':
		return cfs;
	case 'slaw':
		return slaw;
	case 'mmdc':
		return mmdc;
	case 'ksbr':
		return ksbr;
	case 'vanstone':
		return vanstone;
	case 'wieand':
		return wieand;
	case 'wamsley':
		return wamsley;
	case 'lacpd':
		return lacpd;
	case 'gd':
		return gd;
	case 'coleman':
		return coleman;
	default:
		return cpdirect;
	}
};
